// // export default ChangePassword;
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { Container, Box, Paper, Typography, TextField, Button, IconButton, InputAdornment } from "@mui/material";
// import { Visibility, VisibilityOff, LockReset, CheckCircle } from "@mui/icons-material";
// import { useAuth } from '../context/AuthContext';

// function ChangePassword({ connectionString }) {
//   const { user, selectedCompany } = useAuth();
//   const userId = user?.UserId || null;
//   const companyId = selectedCompany?.CompId || null;
//   const userCategory = user?.UserCategory || null;
//   const path = connectionString;

//   const [newPassword, setNewPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [showNewPassword, setShowNewPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [error, setError] = useState("");
//   const [message, setMessage] = useState("");
//   const navigate = useNavigate();

//   const requiredAsteriskStyle = { '& .MuiFormLabel-asterisk': { color: 'red', }, };

//   // Password Match Check
//   useEffect(() => {
//     if (newPassword && confirmPassword && newPassword !== confirmPassword) {
//       setError("Passwords do not match!");
//     } else {
//       setError("");
//     }
//   }, [newPassword, confirmPassword]);

//   // Handle Change Password with auto-navigation
//   const FN_HandleChangePassword = async (e) => {
//     e.preventDefault();
//     setMessage("");

//     if (newPassword !== confirmPassword) {
//       setError("Passwords do not match!");
//       return;
//     }

//     try {
//       const response = await axios.post(`${path}/api/changePassword`, { userId: userId, newPassword: newPassword, companyId, userCategory, });

//       if (response.data.success) {
//         setMessage("Password changed successfully!");
//         // Navigate back after 2 seconds
//         setTimeout(() => {
//           navigate(-1);
//         }, 2000);
//       } else {
//         setError("Failed to change password.");
//       }
//     } catch (err) {
//       setError("Server error. Please try again later.");
//     }
//   };

//   return (
//     <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", position: "relative", overflow: "hidden", background: "linear-gradient(135deg, #e0f7fa 0%, #e1f5fe 25%, #f3e5f5 50%, #fce4ec 75%, #fff3e0 100%)", p: 2 }}>

//       {/* Rotating Gradient Orbs Animation */}
//       <Box sx={{ position: "absolute", inset: 0, overflow: "hidden" }}>
//         <Box sx={{ position: "absolute", width: 500, height: 500, borderRadius: "50%", background: "radial-gradient(circle, rgba(0,161,188,0.15) 0%, transparent 70%)", filter: "blur(60px)", animation: "rotate1 20s linear infinite", top: "10%", left: "10%", }} />
//         <Box sx={{ position: "absolute", width: 450, height: 450, borderRadius: "50%", background: "radial-gradient(circle, rgba(3,78,162,0.15) 0%, transparent 70%)", filter: "blur(60px)", animation: "rotate2 25s linear infinite", top: "20%", right: "15%", }} />
//         <Box sx={{ position: "absolute", width: 480, height: 480, borderRadius: "50%", background: "radial-gradient(circle, rgba(157,36,143,0.15) 0%, transparent 70%)", filter: "blur(60px)", animation: "rotate3 30s linear infinite", bottom: "15%", left: "20%", }} />
//       </Box>

//       {/* Main Card */}
//       <Paper elevation={0} sx={{ position: "relative", zIndex: 1, width: "100%", maxWidth: { xs: "95%", sm: 480 }, maxHeight: { xs: "95vh", sm: "90vh" }, overflow: "auto", background: "rgba(255, 255, 255, 0.25)", backdropFilter: "blur(20px)", borderRadius: { xs: 4, sm: 5 }, border: "1px solid rgba(255, 255, 255, 0.3)", boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(255, 255, 255, 0.2) inset", p: { xs: 3, sm: 4, md: 5 }, }}>
//         {/* Password SVG Icon */}
//         <Box sx={{ display: "flex", justifyContent: "center", mb: { xs: 2, sm: 3 } }}>
//           <Box sx={{ width: { xs: 70, sm: 90 }, height: { xs: 70, sm: 90 }, bgcolor: "rgba(255, 255, 255, 0.6)", backdropFilter: "blur(10px)", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", border: "2px solid rgba(0, 161, 188, 0.3)", boxShadow: "0 8px 20px rgba(0, 161, 188, 0.2)" }}>
//             <LockReset sx={{ fontSize: { xs: 35, sm: 45 }, color: "#00a1bc" }} />
//           </Box>
//         </Box>

//         {/* Heading */}
//         <Typography variant="h4" align="center" fontWeight={700} sx={{ color: "#1a237e", mb: 0.5, fontSize: { xs: "1.5rem", sm: "2rem" } }}>
//           Change Password
//         </Typography>
//         <Typography align="center" sx={{ color: "#546e7a", mb: { xs: 2, sm: 3 }, fontSize: { xs: "0.875rem", sm: "1rem" } }}>
//           Enter your new password below
//         </Typography>

//         {/* Success Message */}
//         {message && (
//           <Box sx={{ bgcolor: "rgba(76, 175, 80, 0.1)", border: "1px solid rgba(76, 175, 80, 0.3)", borderRadius: 3, p: { xs: 1.5, sm: 2 }, mb: { xs: 2, sm: 3 }, display: "flex", alignItems: "center", gap: { xs: 1.5, sm: 2 }, backdropFilter: "blur(10px)" }}>
//             <CheckCircle sx={{ color: "#4caf50", fontSize: { xs: 24, sm: 28 } }} />
//             <Typography sx={{ color: "#2e7d32", fontWeight: 500, fontSize: { xs: "0.875rem", sm: "1rem" } }}>
//               {message}
//             </Typography>
//           </Box>
//         )}

//         {/* Form */}
//         <Box component="form" onSubmit={FN_HandleChangePassword}>

//           {/* New Password */}
//           <TextField fullWidth label="New Password" type={showNewPassword ? "text" : "password"} value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required InputLabelProps={{ sx: requiredAsteriskStyle }}
//             sx={{
//               mb: { xs: 2, sm: 3 },
//               "& .MuiOutlinedInput-root": {
//                 borderRadius: 3,
//                 bgcolor: "rgba(255, 255, 255, 0.6)",
//                 backdropFilter: "blur(10px)",
//                 "& fieldset": { borderColor: "rgba(255, 255, 255, 0.5)" },
//                 "&:hover fieldset": { borderColor: "#00a1bc" },
//                 "&.Mui-focused fieldset": { borderColor: "#00a1bc", borderWidth: 2 }
//               },
//               "& .MuiInputLabel-root": { color: "#546e7a" },
//               "& .MuiInputLabel-root.Mui-focused": { color: "#00a1bc" },
//               "& .MuiOutlinedInput-input": { fontSize: { xs: "0.875rem", sm: "1rem" } }
//             }}
//             InputProps={{
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton onClick={() => setShowNewPassword(!showNewPassword)} edge="end">
//                     {showNewPassword ? <VisibilityOff /> : <Visibility />}
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             }}
//           />

//           {/* Confirm Password */}
//           <TextField fullWidth label="Confirm Password" type={showConfirmPassword ? "text" : "password"} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required InputLabelProps={{ sx: requiredAsteriskStyle }}
//             sx={{
//               mb: { xs: 1.5, sm: 2 },
//               "& .MuiOutlinedInput-root": {
//                 borderRadius: 3,
//                 bgcolor: "rgba(255, 255, 255, 0.6)",
//                 backdropFilter: "blur(10px)",
//                 "& fieldset": { borderColor: "rgba(255, 255, 255, 0.5)" },
//                 "&:hover fieldset": { borderColor: "#00a1bc" },
//                 "&.Mui-focused fieldset": { borderColor: "#00a1bc", borderWidth: 2 }
//               },
//               "& .MuiInputLabel-root": { color: "#546e7a" },
//               "& .MuiInputLabel-root.Mui-focused": { color: "#00a1bc" },
//               "& .MuiOutlinedInput-input": { fontSize: { xs: "0.875rem", sm: "1rem" } }
//             }}
//             InputProps={{
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
//                     {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             }}
//           />

//           {/* Error Message */}
//           {error && (
//             <Box sx={{ bgcolor: "rgba(244, 67, 54, 0.1)", border: "1px solid rgba(244, 67, 54, 0.3)", color: "#c62828", p: { xs: 1, sm: 1.5 }, borderRadius: 3, mb: { xs: 2, sm: 3 }, fontSize: { xs: 12, sm: 14 }, backdropFilter: "blur(10px)", textAlign: "center" }}>
//               {error}
//             </Box>
//           )}

//           {/* Change Password Button */}
//           <Button type="submit" fullWidth variant="contained" disabled={newPassword === "" || confirmPassword === "" || newPassword !== confirmPassword}
//             sx={{
//               background: "linear-gradient(135deg, #00a1bc 0%, #034ea2 100%)",
//               color: "#fff",
//               py: { xs: 1.5, sm: 2 },
//               borderRadius: 3,
//               fontSize: { xs: 14, sm: 15 },
//               fontWeight: 600,
//               textTransform: "none",
//               boxShadow: "0 8px 20px rgba(0, 161, 188, 0.3)",
//               mb: { xs: 1.5, sm: 2 },
//               "&:hover": {
//                 background: "linear-gradient(135deg, #008ea5 0%, #02427d 100%)",
//                 boxShadow: "0 12px 28px rgba(0, 161, 188, 0.4)"
//               },
//               "&:disabled": {
//                 background: "rgba(0, 0, 0, 0.12)",
//                 color: "rgba(0, 0, 0, 0.26)"
//               }
//             }}
//           >
//             Change Password
//           </Button>

//           {/* Cancel Button */}
//           <Button type="button" onClick={() => navigate(-1)} fullWidth variant="outlined"
//             sx={{
//               borderColor: "rgba(0, 161, 188, 0.5)",
//               color: "#00a1bc",
//               py: { xs: 1.5, sm: 2 },
//               borderRadius: 3,
//               fontSize: { xs: 14, sm: 15 },
//               fontWeight: 600,
//               textTransform: "none",
//               backdropFilter: "blur(10px)",
//               "&:hover": {
//                 borderColor: "#00a1bc",
//                 bgcolor: "rgba(0, 161, 188, 0.08)"
//               }
//             }}
//           >
//             Cancel
//           </Button>
//         </Box>
//       </Paper>

//       {/* Animations */}
//       <style>{`
//         @keyframes rotate1 {
//           0% {
//             transform: translate(0, 0) rotate(0deg);
//           }
//           100% {
//             transform: translate(100px, 100px) rotate(360deg);
//           }
//         }

//         @keyframes rotate2 {
//           0% {
//             transform: translate(0, 0) rotate(0deg);
//           }
//           100% {
//             transform: translate(-80px, 80px) rotate(-360deg);
//           }
//         }

//         @keyframes rotate3 {
//           0% {
//             transform: translate(0, 0) rotate(0deg);
//           }
//           100% {
//             transform: translate(60px, -60px) rotate(360deg);
//           }
//         }
//       `}</style>
//     </Box>
//   );
// }

// export default ChangePassword;

import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Box, Paper, Typography, TextField, Button,
  IconButton, InputAdornment, LinearProgress, Divider,
} from "@mui/material";
import {
  Visibility, VisibilityOff, LockReset,
  CheckCircle, Cancel, ShieldOutlined,
} from "@mui/icons-material";
import { useAuth } from "../context/AuthContext";

const FB       = "#1877F2";
const FB_DARK  = "#1464cc";
const FB_LIGHT = "#e7f0fd";

// ── password strength helpers ─────────────────────────────────────────────────
const RULES = [
  { label: "At least 8 characters",        test: (p) => p.length >= 8 },
  { label: "Uppercase letter (A-Z)",        test: (p) => /[A-Z]/.test(p) },
  { label: "Lowercase letter (a-z)",        test: (p) => /[a-z]/.test(p) },
  { label: "Number (0-9)",                  test: (p) => /\d/.test(p) },
  { label: "Special character (!@#$…)",     test: (p) => /[^A-Za-z0-9]/.test(p) },
];

const STRENGTH_META = [
  { label: "Too short", color: "#ef4444" },
  { label: "Weak",      color: "#f97316" },
  { label: "Fair",      color: "#eab308" },
  { label: "Good",      color: "#22c55e" },
  { label: "Strong",    color: "#16a34a" },
  { label: "Very strong", color: "#166534" },
];

function getStrength(pwd) {
  if (!pwd) return 0;
  return RULES.filter((r) => r.test(pwd)).length;
}

// ── shared field sx ───────────────────────────────────────────────────────────
const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 2,
    bgcolor: "#fff",
    "& fieldset": { borderColor: "rgba(0,0,0,0.15)" },
    "&:hover fieldset": { borderColor: FB },
    "&.Mui-focused fieldset": { borderColor: FB, borderWidth: 2 },
  },
  "& .MuiInputLabel-root": { color: "#64748b" },
  "& .MuiInputLabel-root.Mui-focused": { color: FB },
};

function ChangePassword({ connectionString }) {
  const { user, selectedCompany } = useAuth();
  const userId       = user?.UserId          || null;
  const companyId    = selectedCompany?.CompId || null;
  const userCategory = user?.UserCategory     || null;
  const path         = connectionString;

  const [newPassword,       setNewPassword]       = useState("");
  const [confirmPassword,   setConfirmPassword]   = useState("");
  const [showNew,           setShowNew]           = useState(false);
  const [showConfirm,       setShowConfirm]       = useState(false);
  const [error,             setError]             = useState("");
  const [message,           setMessage]           = useState("");
  const [loading,           setLoading]           = useState(false);
  const navigate = useNavigate();

  const strength = useMemo(() => getStrength(newPassword), [newPassword]);
  const strengthMeta = STRENGTH_META[strength] ?? STRENGTH_META[0];
  const passwordsMatch = newPassword && confirmPassword && newPassword === confirmPassword;
  const canSubmit = newPassword && confirmPassword && newPassword === confirmPassword && !loading;

  useEffect(() => {
    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      setError("Passwords do not match!");
    } else {
      setError("");
    }
  }, [newPassword, confirmPassword]);

  const FN_HandleChangePassword = async (e) => {
    e.preventDefault();
    setMessage("");
    if (newPassword !== confirmPassword) { setError("Passwords do not match!"); return; }
    setLoading(true);
    try {
      const response = await axios.post(`${path}/api/changePassword`, {
        userId, newPassword, companyId, userCategory,
      });
      if (response.data.success) {
        setMessage("Password changed successfully!");
        setTimeout(() => navigate(-1), 2000);
      } else {
        setError("Failed to change password.");
      }
    } catch {
      setError("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 64px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#f1f5f9",
        p: { xs: 2, sm: 3 },
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 460 }}>

        {/* ── Card ── */}
        <Paper
          elevation={0}
          sx={{
            borderRadius: 4,
            overflow: "hidden",
            border: "1px solid rgba(0,0,0,0.08)",
            boxShadow: "0 4px 24px rgba(0,0,0,0.07)",
          }}
        >
          {/* Blue header band */}
          <Box
            sx={{
              background: `linear-gradient(135deg, ${FB} 0%, ${FB_DARK} 100%)`,
              px: 3,
              pt: 3.5,
              pb: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1.2,
            }}
          >
            <Box
              sx={{
                width: 62,
                height: 62,
                borderRadius: "50%",
                bgcolor: "rgba(255,255,255,0.18)",
                border: "2px solid rgba(255,255,255,0.35)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <LockReset sx={{ fontSize: 30, color: "#fff" }} />
            </Box>
            <Box sx={{ textAlign: "center" }}>
              <Typography fontWeight={700} fontSize="1.15rem" color="#fff" lineHeight={1.3}>
                Change Password
              </Typography>
              <Typography fontSize="0.78rem" sx={{ color: "rgba(255,255,255,0.72)", mt: 0.3 }}>
                {user?.EmployeeName || user?.UserName || ""}
              </Typography>
            </Box>
          </Box>

          {/* Form body */}
          <Box sx={{ p: { xs: 2.5, sm: 3 } }}>

            {/* Success */}
            {message && (
              <Box
                sx={{
                  display: "flex", alignItems: "center", gap: 1.5,
                  bgcolor: "#f0fdf4", border: "1px solid #bbf7d0",
                  borderRadius: 2.5, p: 1.75, mb: 2.5,
                }}
              >
                <CheckCircle sx={{ color: "#16a34a", fontSize: 22, flexShrink: 0 }} />
                <Typography fontSize="0.875rem" fontWeight={600} color="#15803d">
                  {message}
                </Typography>
              </Box>
            )}

            <Box component="form" onSubmit={FN_HandleChangePassword}>

              {/* New password field */}
              <Typography fontSize="0.78rem" fontWeight={600} color="#374151" mb={0.6}>
                New Password <span style={{ color: "#ef4444" }}>*</span>
              </Typography>
              <TextField
                fullWidth size="small"
                type={showNew ? "text" : "password"}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password"
                sx={{ ...fieldSx, mb: 1.25 }}
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton size="small" onClick={() => setShowNew((p) => !p)} edge="end">
                          {showNew ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  },
                }}
              />

              {/* Strength bar */}
              {newPassword.length > 0 && (
                <Box sx={{ mb: 1.75 }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
                    <Typography fontSize="0.72rem" color="#64748b">Password strength</Typography>
                    <Typography fontSize="0.72rem" fontWeight={600} sx={{ color: strengthMeta.color }}>
                      {strengthMeta.label}
                    </Typography>
                  </Box>
                  <LinearProgress
                    variant="determinate"
                    value={(strength / 5) * 100}
                    sx={{
                      height: 5,
                      borderRadius: 10,
                      bgcolor: "#e2e8f0",
                      "& .MuiLinearProgress-bar": {
                        bgcolor: strengthMeta.color,
                        borderRadius: 10,
                        transition: "width 0.4s ease",
                      },
                    }}
                  />
                </Box>
              )}

              {/* Requirements checklist */}
              {newPassword.length > 0 && (
                <Box
                  sx={{
                    bgcolor: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    borderRadius: 2,
                    p: 1.5,
                    mb: 2,
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 0.6,
                  }}
                >
                  {RULES.map((rule) => {
                    const ok = rule.test(newPassword);
                    return (
                      <Box key={rule.label} sx={{ display: "flex", alignItems: "center", gap: 0.6 }}>
                        {ok
                          ? <CheckCircle sx={{ fontSize: 13, color: "#16a34a", flexShrink: 0 }} />
                          : <Cancel     sx={{ fontSize: 13, color: "#cbd5e1", flexShrink: 0 }} />
                        }
                        <Typography
                          fontSize="0.7rem"
                          sx={{ color: ok ? "#15803d" : "#94a3b8", lineHeight: 1.3 }}
                        >
                          {rule.label}
                        </Typography>
                      </Box>
                    );
                  })}
                </Box>
              )}

              {/* Confirm password field */}
              <Typography fontSize="0.78rem" fontWeight={600} color="#374151" mb={0.6}>
                Confirm Password <span style={{ color: "#ef4444" }}>*</span>
              </Typography>
              <TextField
                fullWidth size="small"
                type={showConfirm ? "text" : "password"}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Re-enter new password"
                sx={{
                  ...fieldSx,
                  mb: 1.5,
                  ...(confirmPassword && {
                    "& .MuiOutlinedInput-root fieldset": {
                      borderColor: passwordsMatch ? "#16a34a" : "#ef4444",
                    },
                  }),
                }}
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        {confirmPassword && (
                          passwordsMatch
                            ? <CheckCircle sx={{ fontSize: 18, color: "#16a34a", mr: 0.5 }} />
                            : <Cancel     sx={{ fontSize: 18, color: "#ef4444", mr: 0.5 }} />
                        )}
                        <IconButton size="small" onClick={() => setShowConfirm((p) => !p)} edge="end">
                          {showConfirm ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  },
                }}
              />

              {/* Error */}
              {error && (
                <Box
                  sx={{
                    bgcolor: "#fef2f2", border: "1px solid #fecaca",
                    borderRadius: 2, p: 1.25, mb: 1.75,
                    display: "flex", alignItems: "center", gap: 1,
                  }}
                >
                  <Cancel sx={{ fontSize: 16, color: "#ef4444", flexShrink: 0 }} />
                  <Typography fontSize="0.8rem" color="#dc2626">{error}</Typography>
                </Box>
              )}

              <Divider sx={{ mb: 2 }} />

              {/* Submit */}
              <Button
                type="submit" fullWidth variant="contained"
                disabled={!canSubmit}
                sx={{
                  bgcolor: FB,
                  py: 1.3,
                  borderRadius: 2,
                  fontSize: "0.875rem",
                  fontWeight: 700,
                  textTransform: "none",
                  boxShadow: "0 4px 14px rgba(24,119,242,0.35)",
                  mb: 1.25,
                  "&:hover": { bgcolor: FB_DARK, boxShadow: "0 6px 20px rgba(24,119,242,0.45)" },
                  "&:disabled": { bgcolor: "action.disabledBackground" },
                }}
                startIcon={<ShieldOutlined sx={{ fontSize: 18 }} />}
              >
                {loading ? "Updating…" : "Update Password"}
              </Button>

              {/* Cancel */}
              <Button
                type="button" fullWidth variant="outlined"
                onClick={() => navigate(-1)}
                sx={{
                  borderColor: "rgba(0,0,0,0.15)",
                  color: "#374151",
                  py: 1.3,
                  borderRadius: 2,
                  fontSize: "0.875rem",
                  fontWeight: 600,
                  textTransform: "none",
                  "&:hover": { borderColor: FB, color: FB, bgcolor: FB_LIGHT },
                }}
              >
                Cancel
              </Button>

            </Box>
          </Box>
        </Paper>

        {/* Security tip */}
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1, mt: 2, px: 0.5 }}>
          <ShieldOutlined sx={{ fontSize: 14, color: "#94a3b8", mt: "1px", flexShrink: 0 }} />
          <Typography fontSize="0.72rem" color="#94a3b8" lineHeight={1.5}>
            Use a strong, unique password you don't use anywhere else. Passwords are hashed and never stored in plain text.
          </Typography>
        </Box>

      </Box>
    </Box>
  );
}

export default ChangePassword;
